import { UserIntegrationBox } from "../UserIntegrationBox";

const IntegrationsTab = ({ state, data, handleCheckboxChangedP, onPurchaseClick, integrationRef }) => {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          {data.admin_access ? (
            <span>
              <input
                type="checkbox"
                id="IsReceivesFlexInquiries"
                name="IsReceivesFlexInquiries"
                checked={state.IsReceivesFlexInquiries}
                onChange={handleCheckboxChangedP}
              />{" "}
              Receives flex website general enquiries{" "}
              <a href="https://help.entegral.net/en/articles/5147614-can-general-flex-website-enquiries-go-to-several-users-at-once" target="_blank">
                <i className={"fa fa-regular fa fa-question-circle-o"} style={{ color: "black" }}></i>
              </a>
            </span>
          ) : null}
        </div>
        <div className="form-group">
          {data.admin_access ? (
            <span>
              <input
                type="checkbox"
                id="IsReceivesListingExpiry"
                name="IsReceivesListingExpiry"
                checked={state.IsReceivesListingExpiry}
                onChange={handleCheckboxChangedP}
              />{" "}
              Receives all listing expiry notifications{" "}
            </span>
          ) : null}
        </div>
        <div className="form-group">
          <span>
            <input
              type="checkbox"
              id="CanSendSMS"
              name="CanSendSMS"
              disabled={data.admin_access ? "" : "disabled"}
              checked={state.CanSendSMS}
              onChange={handleCheckboxChangedP}
            />{" "}
            Can use SMS send &amp; receive{" "}
          </span>
        </div>
        <div className="form-group">
          <span>
            <input
              type="checkbox"
              id="CanSendEmail"
              name="CanSendEmail"
              disabled={data.admin_access ? "" : "disabled"}
              checked={state.CanSendEmail}
              onChange={handleCheckboxChangedP}
            />{" "}
            Can use Email send &amp; receive{" "}
          </span>
        </div>
        <div className="form-group">
          <div style={{ marginLeft: 10 }}>
            <span id="credit_message">
              Credits available: <b>{state.Credit}</b>
            </span>
            <a href="javascript:void(0);" style={{ fontSize: 16, marginLeft: 10 }} onClick={onPurchaseClick}>
              purchase
            </a>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <UserIntegrationBox ref={integrationRef} userID={state.UserID} />
      </div>
    </div>
  );
};

export default IntegrationsTab;
